export const security = {
    title: "নিরাপত্তা",
    description: "দুই ধাপের যাচাই দিয়ে আপনার অ্যাকাউন্ট সুরক্ষিত রাখুন।",
    on: "দুই ধাপের যাচাই চালু আছে।",
    off: "দুই ধাপের যাচাই বন্ধ আছে।",
    enable: "চালু করুন",
    disable: "বন্ধ করুন",
    password: "বর্তমান পাসওয়ার্ড",
    continue: "এগিয়ে যান",
    scan: "অথেনটিকেটর অ্যাপ দিয়ে এই কিউআর কোডটি স্ক্যান করুন, অথবা সেটআপ কী হাতে লিখুন।",
    qrAlt: "অথেনটিকেটর অ্যাপের জন্য কিউআর কোড",
    secret: "সেটআপ কী",
    code: "অ্যাপের ৬ সংখ্যার কোড",
    confirm: "নিশ্চিত করুন",
    otherDevices: "এটি চালু করলে আপনার অন্যান্য ডিভাইস থেকে সাইন আউট হয়ে যাবে।",
    recoveryTitle: "রিকভারি কোডগুলো সংরক্ষণ করুন",
    recoveryBody: "ফোন হারালে প্রতিটি কোড একবার ব্যবহার করা যাবে। কোডগুলো আর দেখানো হবে না।",
    copy: "কোড কপি করুন",
    copied: "কপি হয়েছে।",
    done: "আমি সংরক্ষণ করেছি",
    enabled: "দুই ধাপের যাচাই চালু হয়েছে।",
    disableTitle: "দুই ধাপের যাচাই বন্ধ করুন",
    disableBody: "আপনার পাসওয়ার্ড এবং বর্তমান কোড (বা একটি রিকভারি কোড) লিখুন।",
    disableCode: "কোড",
    disabled: "দুই ধাপের যাচাই বন্ধ হয়েছে।",
    passwordChange: {
        title: "পাসওয়ার্ড",
        body: "সাইন ইনের পাসওয়ার্ড বদলান। অন্য ডিভাইস থেকে সাইন আউট হবে।",
        change: "পাসওয়ার্ড বদলান",
        current: "বর্তমান পাসওয়ার্ড",
        next: "নতুন পাসওয়ার্ড",
        hint: "কমপক্ষে ৮ অক্ষর; খুব প্রচলিত বা শুধু সংখ্যা নয়।",
        save: "নতুন পাসওয়ার্ড সংরক্ষণ",
        saved: "পাসওয়ার্ড বদলানো হয়েছে।",
        requiredTitle: "নিজের পাসওয়ার্ড বেছে নিন",
        requiredBody: "আপনি ব্যবসার দেওয়া প্রথম পাসওয়ার্ড দিয়ে সাইন ইন করেছেন। শুরু করার আগে নিজের পাসওয়ার্ড দিন।",
    },
};
//# sourceMappingURL=security.js.map